var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 4,
    viewBox: "0 0 19 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.19336 3C9.74564 3 10.1934 2.55228 10.1934 2C10.1934 1.44772 9.74564 1 9.19336 1C8.64107 1 8.19336 1.44772 8.19336 2C8.19336 2.55228 8.64107 3 9.19336 3Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1934 3C16.7456 3 17.1934 2.55228 17.1934 2C17.1934 1.44772 16.7456 1 16.1934 1C15.6411 1 15.1934 1.44772 15.1934 2C15.1934 2.55228 15.6411 3 16.1934 3Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19336 3C2.74564 3 3.19336 2.55228 3.19336 2C3.19336 1.44772 2.74564 1 2.19336 1C1.64107 1 1.19336 1.44772 1.19336 2C1.19336 2.55228 1.64107 3 2.19336 3Z",
    stroke: "#757575",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthers);
export default __webpack_public_path__ + "static/media/others.df532daf903f0fb7e5006fab2d4ea98c.svg";
export { ForwardRef as ReactComponent };